import { Component } from 'vue-property-decorator';
import './no-task-multi-sorting-modal.component.scss';
import { ValidationProvider } from 'vee-validate';
import BaseSortingModal from '../common-sorting/base-sorting-modal.component';
import SortingModal from '../common-sorting/sorting-modal.component';
import { SortModalType } from '@/tsort/enum/sort-modal-type.enum';
import NumericKeyboard from '@/common/components/numeric-keyboard/numeric-keyboard.component';
import SwipeButton from '@/common/components/swipe-button/swipe-button';
import { DisplayType } from '@/common/enum/display-type.enum';
import { ScanMode } from '@/common/enum/scan-mode.enum';
import AppConstants from '@/common/constants/app.constants';

@Component({})
export default class NoTaskMultiSortingModal extends BaseSortingModal {
  // ------------------------- Start Vue lifecycle -------------------
  mounted(): void {
    window.addEventListener('keydown', this.handlePressButtonEvent);
  }

  beforeDestroy(): void {
    window.removeEventListener('keydown', this.handlePressButtonEvent);
  }

  updated(): void {
    (this.$refs.inputSortingModalRef as InstanceType<typeof ValidationProvider>)?.reset();
    this.$refs.swipeButton?.handleError(false);
  }
  // ------------------------- End Vue lifecycle -------------------

  get getModalTitle() {
    if (this.modeType === ScanMode.ONE_HUNDRED_PERCENT_SCAN) {
      return 'スキャン・投入して発進';
    }
    return '投入数を入力して発進';
  }

  render() {
    return (
      <div v-frag>
        {this.targetTaskList.length > 0 ? (
          <SortingModal
            modalScan="no-task-multi-sorting-modal"
            isShow={this.isShow}
            type={SortModalType.SCAN}
            title={this.getModalTitle}
            targetTaskList={this.targetTaskList}
            targetTask={this.targetTask}
            currentTaskListIndex={this.currentTaskListIndex}
            scanCodePattern={this.scanCodePattern}
            chuteModeType={this.chuteModeType}
            lastChuteNo={this.lastChuteNo}
            fieldNameScanCode={this.fieldNameScanCode}
            dataSortingTable={this.dataSortingTable}
            inputQuantity={this.inputQuantity}
            maxInputQuantity={this.maxInputQuantity === 0 ? AppConstants.QUANTITY_MAX_VALUE : this.maxInputQuantity}
            displayNumericKeyboard={!this.modeType}
            modeType={this.modeType}
            inputQuantityStore={this.inputQuantityStore}
            onExitBtn={this.exit}
            onBackTaskList={this.backTaskList}
            onNextTaskList={this.nextTaskList}
          >
            <template slot="inputQuantity">
              {this.modeType === ScanMode.ONE_HUNDRED_PERCENT_SCAN ? (
                <ValidationProvider
                  name={this.fieldNameScanCode}
                  scopedSlots={this.getScanCodeInputScopeSlot}
                  ref="inputSortingModalRef"
                  rules={`is:${this.scanCodePattern}|required`}
                ></ValidationProvider>
              ) : (
                <ValidationProvider
                  name="投入数"
                  scopedSlots={this.getInputScopedSlot}
                  rules={`required`}
                ></ValidationProvider>
              )}
            </template>
            <template slot="swipeButton">
              <SwipeButton
                on-finished-swipe={() => this.swipeToScanCode()}
                ref="swipeButton"
                displayType={DisplayType.MODAL}
                text="OK"
                class="font-weight-bold"
              />
            </template>
            <template slot="acceptButton">
              <button id="accept-btn" class="accept-btn" on-click={() => this.acceptBtn()}>
                発進
              </button>
            </template>
            <template slot="numericKeyboard">
              <NumericKeyboard
                acceptText=""
                on-numberHandle={this.onClickNumericCalcButton}
                on-moveBtn={this.increaseCurrentPositionInputField}
                on-BackBtn={this.decreaseCurrentPositionInputField}
                on-deleteBtn={this.deleteInputQuantity}
                on-acceptBtn={this.acceptBtn}
              ></NumericKeyboard>
            </template>
          </SortingModal>
        ) : null}
      </div>
    );
  }
}
